<template>
  <li
    class="header__links__items header__email-signup header__email-signup--mobile"
  >
    <lightbox-button target="lightboxMarketoEmailSignup">
      <p class="header__links--child__label">{{ label }}</p>
    </lightbox-button>
    <lightbox name="lightboxMarketoEmailSignup">
      <lightbox-wrapper class="lightbox__wrapper--white">
        <lightbox-close></lightbox-close>
        <header>
          <h2 class="font__color--orange">{{ header.blog.marketo.header }}</h2>
        </header>
        <marketo
          :id="header.blog.marketo.id"
          :cta="header.blog.marketo.cta"
        ></marketo>
        <div class="header__rss">
          <a :href="header.blog.rss.href" target="_blank">
            <svg class="header__rss__icon">
              <use xlink:href="#rss" />
            </svg>
            {{ header.blog.rss.label }}
          </a>
        </div>
      </lightbox-wrapper>
    </lightbox>
  </li>
</template>

<script>
import Lightbox from '../lightbox/Lightbox.vue';
import LightboxButton from '../lightbox/LightboxButton.vue';
import LightboxClose from '../lightbox/LightboxClose.vue';
import LightboxWrapper from '../lightbox/LightboxWrapper.vue';
import Marketo from '../marketo/Marketo.vue';
import VueHelpers from '../../mixins/vue-helpers';

export default {
  mixins: [VueHelpers],
  props: ['header', 'label'],
  components: {
    Lightbox,
    LightboxButton,
    LightboxClose,
    LightboxWrapper,
    Marketo
  }
};
</script>
